module.exports = __webpack_public_path__ + "img/Configure-background.d68c0d6b.svg";